export const CATERING_BASE = '/catering';

export type CateringViewTab = 'inquiries' | 'links';

export type CateringRouteState = {
  view: CateringViewTab | null;
  inquiryId: number | null;
  redirectTo: string | null;
};

const normalizePath = (pathname: string) =>
  pathname.length > 1 && pathname.endsWith('/')
    ? pathname.slice(0, -1)
    : pathname;

export const cateringViewPath = (view: CateringViewTab) =>
  `${CATERING_BASE}/${view}`;

export const cateringRecordPath = (inquiryId: number) =>
  `${CATERING_BASE}/inquiries/${inquiryId}`;

const route = (
  patch: Partial<CateringRouteState> = {},
): CateringRouteState => ({
  view: null,
  inquiryId: null,
  redirectTo: null,
  ...patch,
});

export const resolveCateringRoute = (pathname: string): CateringRouteState => {
  const normalized = normalizePath(pathname);
  if (
    normalized !== CATERING_BASE &&
    !normalized.startsWith(`${CATERING_BASE}/`)
  ) {
    return route();
  }

  const rest =
    normalized === CATERING_BASE
      ? ''
      : normalized.slice(CATERING_BASE.length + 1);
  const [section, idPart, detailPart, ...extra] = rest
    .split('/')
    .filter(Boolean);

  if (!section) return route();
  if (extra.length > 0) return route({ redirectTo: CATERING_BASE });

  if (section === 'links') {
    if (idPart) return route({ redirectTo: cateringViewPath('links') });
    return route({ view: 'links' });
  }

  if (section !== 'inquiries') return route({ redirectTo: CATERING_BASE });

  if (!idPart) return route({ view: 'inquiries' });

  const inquiryId = Number(idPart);
  if (!/^\d+$/.test(idPart) || inquiryId < 1) {
    return route({ redirectTo: cateringViewPath('inquiries') });
  }

  // Older links (emails, bookmarks) carry a detail tab from the modal this
  // page used to have; the record shows transcript and email in its activity.
  return route({
    view: 'inquiries',
    inquiryId,
    redirectTo: detailPart ? cateringRecordPath(inquiryId) : null,
  });
};
